export const LOGO_CONTAINER_DIAMETER = 160;
export const LOGO_CONTAINER_DIAMETER_MOBILE = 83;
export const LOGO_DIAMETER = LOGO_CONTAINER_DIAMETER - 8;
export const LOGO_DIAMETER_MOBILE = LOGO_CONTAINER_DIAMETER_MOBILE - 8;

export const MY_PROFILE_QUERY_KEY = 'Settings-MyProfile';
